module.exports = __webpack_public_path__ + "img/Mason_jar_pour_mariage.6869af5.jpg";